import React, { Component } from "react";
import { BiFilter, BiTrash, BiTrashAlt, BiX } from "react-icons/bi";
import { connect } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  ModalFooter,
  Popover,
  PopoverBody,
} from "reactstrap";
import AssigneeComponent from "../../components/FilterRowComponents/AssigneeComponent";
import BooleanSelectComponent from "../../components/FilterRowComponents/BooleanSelectComponent";
import { MAIN_ROW_FILTER_TYPES } from "../../components/FilterRowComponents/data";
import DateComponent from "../../components/FilterRowComponents/DateComponent";
import InputComponent from "../../components/FilterRowComponents/InputComponent";
import PriorityComponentFilter from "../../components/FilterRowComponents/PriorityComponent";
import PrivacyStatusComponent from "../../components/FilterRowComponents/PrivacyStatusComponent";
import ProgressComponent from "../../components/FilterRowComponents/ProgressComponent";
import SelectFilterOnComponent from "../../components/FilterRowComponents/SelectFilterOnComponent";
import StatusComponent from "../../components/FilterRowComponents/StatusComponent";
import * as actionCreators from "../../modules/actions/index";

class ActionsFilterComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filtersArray: [],
      popoverOpen: false,
      filterLength: 0,
    };
  }

  toggle = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.filterParams) !==
      JSON.stringify(nextProps.filterParams)
    ) {
      const filters = nextProps.filterParams.filtersDoc;
      console.log("fill-", filters);
      if (filters) {
        const filtersToArray = this.convertToFilterArray(filters);

        this.setState({
          filterLength: filtersToArray.length,
        });
      }
    }
  }

  componentDidMount() {
    const { filterParams, updateFilterParams } = this.props;
    if (filterParams.filtersDoc) {
      const filtersArr = this.convertToFilterArray(filterParams.filtersDoc);
      this.setState({
        filtersArray: filtersArr,
        filterLength: filtersArr.length,
      });
    } else {
      updateFilterParams({ ...filterParams, filtersDoc: [] });
    }
  }

  addNewFilter = () => {
    this.setState({
      filtersArray: [...this.state.filtersArray, { booleanParameter: true }],
    });
  };

  handleRowDataChange = (index, value, key) => {
    const arr = [...this.state.filtersArray];
    const item = arr[index];
    item[key] = value;
    arr[index] = item;
    this.setState({ filtersArray: [...arr] });
  };

  deleteRowItem = index => {
    const arr = [...this.state.filtersArray];
    arr.splice(index, 1);
    this.setState({ filtersArray: [...arr] },()=>{
      if(this.state.filtersArray.length===0){
       this.clearFilters()
      }else{
        this.applyFilters()
      }
    });
  };

  clearFilters = () => {
    this.setState({ filtersArray: [] });
    const doc = {};

    const { filterParams } = this.props;

    if (filterParams.filtersDoc.title) {
      doc.title = filterParams.filtersDoc.title;
    }
    this.props.updateFilterParams({
      filtersDoc: doc,
    });
    this.toggle();
  };

  applyFilters = () => {
    const filterObject = this.convertToFilterObject();
    console.log(filterObject);
    this.props.updateFilterParams({
      filtersDoc: filterObject,
    });
  };

  convertToFilterObject = () => {
    const arr = [...this.state.filtersArray];
    let filterObject = {};

    const { filterParams } = this.props;
    console.log(filterParams);
    if (filterParams.filtersDoc.title) {
      console.log("first");
      filterObject.title = filterParams.filtersDoc.title;
    }

    arr.forEach(ele => {
      if (ele.filterOn === "STATUS") {
        filterObject.status = {
          value: ele.status, //type - string
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "DUE_DATE") {
        filterObject.dueDate = {
          value: ele.dueDate, //type -string or array
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "COMPLETED_DATE") {
        filterObject.completedDate = {
          value: ele.completedDate, //type -string or array
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "CREATED_DATE") {
        filterObject.createdOn = {
          value: ele.createdOn, //type -string or array
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "ASSIGNEE") {
        filterObject.assignee = {
          value: ele.assignee, //type object
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "PROGRESS") {
        filterObject.progress = {
          value: ele.progress, //type array
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "PRIORITY") {
        filterObject.priority = {
          value: ele.priority, //type number
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "LINKED_ACTIONS") {
        filterObject.linkedActions = {
          value: ele.linkedActions, //type number
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "CREATED_BY") {
        filterObject.createdBy = {
          value: ele.createdBy, //type number
          equalsOrIncludes: ele.booleanParameter,
        };
      } else if (ele.filterOn === "PRIVACY_STATUS") {
        filterObject.privacyStatus = {
          value: ele.privacyStatus, //type number
          equalsOrIncludes: ele.booleanParameter,
        };
      }
    });

    return filterObject;
  };

  convertToFilterArray = object => {
    let filterObject = { ...object };
    let filtersArr = [];
    for (const key in filterObject) {
      if (Object.hasOwnProperty.call(object, key)) {
        const ele = object[key];

        if (key === "status") {
          filtersArr.push({
            filterOn: "STATUS",
            status: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "dueDate") {
          filtersArr.push({
            filterOn: "DUE_DATE",
            dueDate: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "completedDate") {
          filtersArr.push({
            filterOn: "COMPLETED_DATE",
            completedDate: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "createdOn") {
          filtersArr.push({
            filterOn: "CREATED_DATE",
            createdOn: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "assignee") {
          filtersArr.push({
            filterOn: "ASSIGNEE",
            assignee: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "progress") {
          filtersArr.push({
            filterOn: "PROGRESS",
            progress: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "priority") {
          filtersArr.push({
            filterOn: "PRIORITY",
            priority: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "linkedActions") {
          filtersArr.push({
            filterOn: "LINKED_ACTIONS",
            linkedActions: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "createdBy") {
          filtersArr.push({
            filterOn: "CREATED_BY",
            createdBy: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        } else if (key === "privacyStatus") {
          filtersArr.push({
            filterOn: "PRIVACY_STATUS",
            privacyStatus: ele.value,
            booleanParameter: ele.equalsOrIncludes,
          });
        }
      }
    }

    return filtersArr;
  };

  render() {
    const { filtersArray, filterLength } = this.state;
    return (
      <div>
        <div
          className="action-table-filter-btn btn"
          style={{ height: "38px" }}
          onClick={this.toggle}
        >
          <span>Filters</span>
          <BiFilter className="cursor-pointer" fontSize={"26px"} id="Modal1" />
          {filterLength > 0 ? (
            <span className="actions-filter-counter">{filterLength}</span>
          ) : (
            ""
          )}
        </div>

        <Popover
          isOpen={this.state.popoverOpen}
          target="Modal1"
          toggle={this.toggle}
          placement="bottom"
          className="action-filters-popover"
        >
          <PopoverBody className={"action-filters-popover-body"}>
            <div className="action-filters-header-div">
              <h5>Filters</h5>

              <BiX fontSize="26px" onClick={this.toggle} />
            </div>

            <div className="filters-row-div my-3">
              {filtersArray.map((item, index) => {
                return (
                  <div className="action-filter-row-item my-2">
                    <span>WHERE</span>
                    <SelectFilterOnComponent
                      item={item}
                      onDataChange={this.handleRowDataChange}
                      index={index}
                      options={MAIN_ROW_FILTER_TYPES}
                    />
                    <BooleanSelectComponent
                      item={item}
                      onDataChange={this.handleRowDataChange}
                      index={index}
                    />

                    {item.filterOn === "STATUS" ? (
                      <StatusComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                      />
                    ) : item.filterOn === "DUE_DATE" ? (
                      <DateComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey="dueDate"
                      />
                    ) : item.filterOn === "COMPLETED_DATE" ? (
                      <DateComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey="completedDate"
                      />
                    ) : item.filterOn === "CREATED_DATE" ? (
                      <DateComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey="createdOn"
                      />
                    ) : item.filterOn === "ASSIGNEE" ? (
                      <AssigneeComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey={"assignee"}
                      />
                    ) : item.filterOn === "PROGRESS" ? (
                      <ProgressComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                      />
                    ) : item.filterOn === "PRIORITY" ? (
                      <PriorityComponentFilter
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                      />
                    ) : item.filterOn === "LINKED_ACTIONS" ? (
                      <InputComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey="linkedActions"
                      />
                    ) : item.filterOn === "CREATED_BY" ? (
                      <AssigneeComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                        dKey="createdBy"
                      />
                    ) : item.filterOn === "PRIVACY_STATUS" ? (
                      <PrivacyStatusComponent
                        item={item}
                        onDataChange={this.handleRowDataChange}
                        index={index}
                      />
                    ) : (
                      ""
                    )}

                    <div style={{ marginLeft: "auto" }}>
                      <BiTrash
                        size={"22px"}
                        className="cursor-pointer"
                        onClick={() => this.deleteRowItem(index)}
                        color="gray"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="my-2">
              <Button size="sm" onClick={this.addNewFilter}>
                {" "}
                + Add Filter{" "}
              </Button>
            </div>
          </PopoverBody>

          <ModalFooter>
            <Button color="primary" onClick={this.applyFilters}>
              Apply Filters
            </Button>
            <Button onClick={() => this.clearFilters()}>Clear</Button>
          </ModalFooter>
        </Popover>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    filterParams: state.sortFilterParams.actions.filter,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateFilterParams: data =>
      dispatch(actionCreators.updateActionsFilter(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionsFilterComponent);
